<template>
  <div id="cart">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- menu detail -->
      <section>
        <div
          class="l-main l-main--bg-border l-main--no-pd-bot l-main--bg-border--green pt-60"
        >
          <div class="l-main__head">
            <a
              href="#"
              @click.prevent="backPagePrevious()"
              class="l-main__head--control l-main__head--control--back"
            >
              <img src="/assets/images/icon/icon-back-white.svg?v=2" alt="" />
            </a>
            <div class="l-main__head--title">カートを確認</div>
            <a href="javascript:void(0)" class="l-main__head--control"></a>
          </div>
          <div class="l-check-cart" v-if="cartIsEmpty">
            <div class="l-check-cart__head">
              <div class="cart-is-empty">
                <span class="message">カート内に商品がありません。</span>
              </div>
            </div>
          </div>
          <div class="l-cart-error" v-if="hasCartError">
            <span class="message">現在ご注文できない店舗・商品がございます。ご確認ください。</span>
          </div>
          <div class="l-check-cart" v-for="(tenantCart, index) in cartData" :key="index">
            <div class="l-check-cart__head">
              <div class="l-check-cart__title"><router-link :to="`/mobileorder/shop/${tenantCart.tenantId}/${getOrderTypeString(tenantCart.orderType)}`">{{getTenantName(tenantCart.tenantId)}}</router-link></div>
              <div class="c-box-time-head mt-16 cartError" v-if="tenantCart.tenantError">
                <div class="c-box-time-head__icon">
                  <img src="/assets/images/icon/icon-warning.svg" alt="" />
                </div>
                <div class="c-box-time-head__title">{{getErrorTitle(tenantCart.tenantError)}}</div>
              </div>
              <div class="c-estimated-group c-estimated-group--vertical-center c-estimated-group--xl" v-if="isEnableTimebase(tenantCart)">
                <div class="c-estimated c-estimated-horizon">
                  <img src="/assets/images/icon/icon-clock.svg" alt="" />受け取り目安
                </div>
                <div class="c-estimated-time">{{getEstimateTime(tenantCart)}}</div>
              </div>
              <hr />
              <div>
                <div class="c-cart-box mb-16" v-for="(product, index) in tenantCart.orderProducts" :key="index">
                  <div class="c-cart-box__head">
                    <div class="c-cart-box__img product-image">
                      <img :src="getImgSrc(product.image)" alt="" />
                    </div>
                    <div class="c-cart-box__control">
                      <div class="c-quantity mb-8">
                        <button class="c-quantity__btn" data-type="minus" @click.prevent="decrementQuantity(tenantCart, index)">
                          <img src="/assets/images/icon/icon-minus.svg" alt="" />
                        </button>
                        <input
                          class="c-quantity__input"
                          type="text"
                          disabled
                          style="opacity: 1"
                          v-model="product.tmpQuantity"
                        />
                        <button class="c-quantity__btn" data-type="plus" @click.prevent="incrementQuantity(tenantCart, index)">
                          <img src="/assets/images/icon/icon-plus.svg" alt="" />
                        </button>
                      </div>
                      <div class="c-control-cart">
                        <button class="c-control-cart__btn" @click.prevent="removeProduct(tenantCart, index)">削除</button>
                      </div>
                    </div>
                  </div>
                  <div class="c-cart-box__body">
                    <div class="c-box-time-head mt-16 cartError" v-if="product.productError">
                    <div class="c-box-time-head__icon">
                      <img src="/assets/images/icon/icon-warning.svg" alt="" />
                    </div>
                    <div class="c-box-time-head__title">{{product.productError.message}}</div>
                  </div>
                    <ul>
                      <li>
                        <div class="c-cart-box__name">{{product.productName}}</div>
                        <div class="c-cart-box__price" v-if="product.price > 0">
                          {{priceFormat(getCartProductPriceTaxed(product, tenantCart.handlingFormat == '2' ? 'pickup' : '', tenantCart.handlingFormatSetting))}}円<br /><small>（税込）</small>
                        </div>
                      </li>
                      <li v-for="(option, optionIndex) in product.options" :key="optionIndex">
                        <div class="c-cart-box__name">{{option.optionName}}</div>
                        <div class="c-cart-box__price" v-if="product.price > 0">
                          {{priceFormat(getCartOptionPriceTaxed(product, option, tenantCart.handlingFormat == '2' ? 'pickup' : '', tenantCart.handlingFormatSetting))}}円<br /><small>（税込）</small>
                        </div>
                      </li>
                      <li v-if="getTenantTimebaseReservation(tenantCart.tenantId) && tenantCart.reservationNumberOfPeople > 0 ">
                        {{tenantCart.reservationNumberOfPeople}} 人
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="l-check-cart__body">
              <div class="c-calc-price mb-8">
                <ul class="mb-16">
                  <li>
                    <div>合計点数</div>
                    <div>{{getProductCount(tenantCart)}}点</div>
                  </li>
                  <li v-if="tenantCart.priceAmount1 > 0">
                    <div><small>小計</small><small>（税率8% 税別）</small></div>
                    <div><small>{{priceFormat(tenantCart.priceAmount1)}}円</small></div>
                  </li>
                  <li v-if="tenantCart.priceAmount2 - tenantCart.comissionFee > 0">
                    <div><small>小計</small><small>（税率10% 税別）</small></div>
                    <div><small>{{priceFormat(tenantCart.priceAmount2 - tenantCart.comissionFee)}}円</small></div>
                  </li>
                  <li v-if="tenantCart.comissionFee > 0">
                    <div><small>手数料</small><small>（税率10% 税別）</small></div>
                    <div><small>{{priceFormat(tenantCart.comissionFee)}}円</small></div>
                  </li>
                  <li v-if="tenantCart.taxAmount1 > 0">
                    <div><small>税額(8%)</small></div>
                    <div><small>{{priceFormat(tenantCart.taxAmount1)}}円</small></div>
                  </li>
                  <li v-if="tenantCart.taxAmount2 > 0">
                    <div><small>税額(10%)</small></div>
                    <div><small>{{priceFormat(tenantCart.taxAmount2)}}円</small></div>
                  </li>
                  <li v-if="tenantCart.discountAmount > 0">
                    <div><small>クーポン券適用</small></div>
                    <div><small class="discount">-{{priceFormat(tenantCart.discountAmount)}}円</small></div>
                  </li>
                  <hr />
                  <li v-if="tenantCart.totalAmount > 0">
                    <div>合計<small>（税込）</small></div>
                    <div>{{priceFormat(tenantCart.totalAmount)}}円</div>
                  </li>
                </ul>
                <div class="mb-8" v-if="tenantCart.totalAmount > 0">
                  ※消費税は小計に記載の本体価格に対し計算の上、合計(税込)額を表示しています<br />
                  ※消費税の計算により店頭価格と端数が異なる場合がございます
                </div>
              </div>
              <div class="c-box-method" v-if="tenantCart.handlingFormat == '1' || tenantCart.handlingFormat == '2' || index+1 == cartData.length">
                <div class="c-box-method__title mb-20" v-if="tenantCart.handlingFormat == '1' || tenantCart.handlingFormat == '2'">
                  ご利用方法を選択してください
                </div>
                <div class="c-box-method__title mb-8" v-else-if="tenantCart.handlingFormat == '3' || tenantCart.handlingFormat == '4'">
                  受け取る車の情報を入力してください
                </div>
                <ul class="mb-28" v-if="tenantCart.orderType != 3">
                  <li v-if="getAvailableHandlingFormats(tenantCart, getTenant(tenantCart.tenantId)).indexOf(1) != -1">
                    <label class="c-radio">
                      <input 
                        type="radio" 
                        :name="`delivery_place_${tenantCart.orderId}`" 
                        :id="`delivery_place_${tenantCart.orderId}_1`" 
                        value="1" 
                        v-model="tenantCart.handlingFormat" 
                        @change="changeDeliveryPlace(tenantCart)"
                      />
                      <span class="c-radio__checkmark"></span>
                    </label>
                    <label :for="`delivery_place_${tenantCart.orderId}_1`" class="c-box-method__name">
                      持ち帰り用
                    </label>
                  </li>
                  <li v-if="getAvailableHandlingFormats(tenantCart, getTenant(tenantCart.tenantId)).indexOf(2) != -1">
                    <label class="c-radio">
                      <input
                        type="radio" 
                        :name="`delivery_place_${tenantCart.orderId}`" 
                        :id="`delivery_place_${tenantCart.orderId}_2`" 
                        value="2" 
                        v-model="tenantCart.handlingFormat" 
                        @change="changeDeliveryPlace(tenantCart)"
                      />
                      <span class="c-radio__checkmark"></span>
                    </label>
                    <label :for="`delivery_place_${tenantCart.orderId}_2`" class="c-box-method__name">
                      店内でお食事<br />
                      <div class="c-radio__subform-title_tableno mb-8" v-if="mobileOrderConfig.tableOrderDescription">
                        {{mobileOrderConfig.tableOrderDescription}}<br v-if="mobileOrderConfig.tableOrderDescription" />
                        テーブルお届け番号の入力は<a href="javascripit:void(0)" @click.prevent="openTableNoInput(tenantCart)">コチラ</a>から
                      </div>
                      <div class="c-radio__subform-input_tableno" v-show="tenantCart.showTableNoInput">
                        <span>T-</span>
                        <input class="c-radio__subform-input" type="tel" placeholder="テーブル番号を入力" v-model="tenantCart.deliveryPlaceDetail.tableNo" @change.prevent="updateTableNo($event, tenantCart)" />
                      </div>
                    </label>
                  </li>
                  <!-- drivethru -->
                  <li v-if="index+1 == cartData.length && tenantCart.handlingFormat == 3">
                    <label class="c-radio delivery">
                      <input
                        type="hidden" 
                        :name="`delivery_place_${tenantCart.orderId}`" 
                        :id="`delivery_place_${tenantCart.orderId}_3`" 
                        value="3" 
                        v-model="tenantCart.handlingFormat"
                      />
                    </label>
                    <label class="c-box-method__name delivery">
                      <div class="c-radio__subform-title">受け取り場所</div>
                      <div class="c-radio__place">
                        <div class="place-name">{{mobileOrderConfig.drivethruAreaName}}</div>
                        <button class="c-btn small" @click="openLocationPopup('drivethru')">場所</button>
                      </div>
                      <div class="c-radio__subform-title">車のナンバー（4桁数字）<span class="required">※必須</span></div>
                      <div class="c-radio__subform-guide d-flex">
                        <div class="">入力例）0120</div>
                        <img src="/assets/images/car_num.png" alt="">
                      </div>
                      <input class="c-radio__subform-input" type="tel" placeholder="車のナンバー（4桁数字）を入力" :value="tenantCart.deliveryPlaceDetail.carNo" pattern="/[0-9]{2}-*[0-9]{2}/" @change="updateCarNo($event)" />
                      <div class="error" v-if="errorCarNo">{{errorCarNo}}</div>
                      <div class="c-radio__subform-title">車の色<span class="required">※必須</span></div>
                      <select class="selmodal" @change="updateCarColor($event)" name="car_color_drivethru">
                        <option value="">選択してください</option>
                        <option value="黒" :selected="tenantCart.deliveryPlaceDetail.carColor=='黒'">黒</option>
                        <option value="白" :selected="tenantCart.deliveryPlaceDetail.carColor=='白'">白</option>
                        <option value="シルバー" :selected="tenantCart.deliveryPlaceDetail.carColor=='シルバー'">シルバー</option>
                        <option value="グレー" :selected="tenantCart.deliveryPlaceDetail.carColor=='グレー'">グレー</option>
                        <option value="赤" :selected="tenantCart.deliveryPlaceDetail.carColor=='赤'">赤</option>
                        <option value="青" :selected="tenantCart.deliveryPlaceDetail.carColor=='青'">青</option>
                        <option value="水色" :selected="tenantCart.deliveryPlaceDetail.carColor=='水色'">水色</option>
                        <option value="紫" :selected="tenantCart.deliveryPlaceDetail.carColor=='紫'">紫</option>
                        <option value="黄" :selected="tenantCart.deliveryPlaceDetail.carColor=='黄'">黄</option>
                        <option value="オレンジ" :selected="tenantCart.deliveryPlaceDetail.carColor=='オレンジ'">オレンジ</option>
                        <option value="グリーン" :selected="tenantCart.deliveryPlaceDetail.carColor=='グリーン'">グリーン</option>
                        <option value="ピンク" :selected="tenantCart.deliveryPlaceDetail.carColor=='ピンク'">ピンク</option>
                        <option value="メタリック" :selected="tenantCart.deliveryPlaceDetail.carColor=='メタリック'">メタリック</option>
                      </select>
                      <div class="error" v-if="errorCarColor">{{errorCarColor}}</div>
                    </label>
                  </li>
                  <!-- parkandpickup -->
                  <li v-if="index+1 == cartData.length && tenantCart.handlingFormat == 4">
                    <label class="c-radio delivery">
                      <input
                        type="hidden" 
                        :name="`delivery_place_${tenantCart.orderId}`" 
                        :id="`delivery_place_${tenantCart.orderId}_4`" 
                        value="4" 
                        v-model="tenantCart.handlingFormat"
                      />
                    </label>
                    <label class="c-box-method__name delivery">
                      <div class="c-radio__subform-title">受け取り場所</div>
                      <div class="c-radio__place">
                        <div class="place-name">{{mobileOrderConfig.parkAndPickupAreaName}}</div>
                        <button class="c-btn small" @click.prevent="openLocationPopup('parkandpickup')">場所</button>
                      </div>
                      <div class="c-radio__subform-title">車のナンバー（4桁数字）<span class="required">※必須</span></div>
                      <div class="c-radio__subform-guide d-flex">
                        <div class="">入力例）0120</div>
                        <img src="/assets/images/car_num.png" alt="">
                      </div>
                      <input class="c-radio__subform-input" type="tel" placeholder="車のナンバー（4桁数字）を入力" :value="tenantCart.deliveryPlaceDetail.carNo" pattern="/[0-9]{2}-*[0-9]{2}/" @change="updateCarNo($event)" />
                      <div class="error" v-if="errorCarNo">{{errorCarNo}}</div>
                      <div class="c-radio__subform-title">車の色<span class="required">※必須</span></div>
                      <select class="selmodal" @change="updateCarColor($event)" name="car_color_parkandpickup">
                        <option value="">選択してください</option>
                        <option value="黒" :selected="tenantCart.deliveryPlaceDetail.carColor=='黒'">黒</option>
                        <option value="白" :selected="tenantCart.deliveryPlaceDetail.carColor=='白'">白</option>
                        <option value="シルバー" :selected="tenantCart.deliveryPlaceDetail.carColor=='シルバー'">シルバー</option>
                        <option value="グレー" :selected="tenantCart.deliveryPlaceDetail.carColor=='グレー'">グレー</option>
                        <option value="赤" :selected="tenantCart.deliveryPlaceDetail.carColor=='赤'">赤</option>
                        <option value="青" :selected="tenantCart.deliveryPlaceDetail.carColor=='青'">青</option>
                        <option value="水色" :selected="tenantCart.deliveryPlaceDetail.carColor=='水色'">水色</option>
                        <option value="紫" :selected="tenantCart.deliveryPlaceDetail.carColor=='紫'">紫</option>
                        <option value="黄" :selected="tenantCart.deliveryPlaceDetail.carColor=='黄'">黄</option>
                        <option value="オレンジ" :selected="tenantCart.deliveryPlaceDetail.carColor=='オレンジ'">オレンジ</option>
                        <option value="グリーン" :selected="tenantCart.deliveryPlaceDetail.carColor=='グリーン'">グリーン</option>
                        <option value="ピンク" :selected="tenantCart.deliveryPlaceDetail.carColor=='ピンク'">ピンク</option>
                        <option value="メタリック" :selected="tenantCart.deliveryPlaceDetail.carColor=='メタリック'">メタリック</option>
                      </select>
                      <div class="error" v-if="errorCarColor">{{errorCarColor}}</div>
                      <div class="c-radio__subform-title">駐車場番号<span class="required">※必須</span></div>
                      <div class="c-radio__subform-guide">
                        入力例）B-10
                        <img src="" />
                      </div>
                      <input class="c-radio__subform-input" type="tel" placeholder="駐車場番号を入力" :value="tenantCart.deliveryPlaceDetail.parkingNo || 'B-'" pattern="/B-[0-9]+/" @change="updateParkingNo($event)" />
                      <div class="error" v-if="errorParkingNo">{{errorParkingNo}}</div>
                    </label>
                  </li>
                </ul>
                <div id="btn_checkout" class="c-btn c-btn--red box-center" @click.prevent="checkout" v-if="index + 1 == cartData.length && getTenantCategory(tenantCart.tenantId) == 5">決済画面に進む</div>
              </div>
              <div class="c-box-method mb-32">
                <template v-if="getTenantTimebasePickup(tenantCart)">
                  <div class="c-box-method__title mb-20">
                    受取日の指定
                  </div>
                  <div class="mb-8">
                    ※翌日以降のお受け取りをご希望のお客さまはご入力ください
                  </div>
                  <v-date-picker 
                    class="inline-block h-full" 
                    locale="ja" 
                    v-model="tenantCart.receiveDate" 
                    :masks="masks" mode="date" 
                    :max-date="getMaxReceveDate(tenantCart.handlingFormatSetting.receiveDateMargin)" 
                    :min-date="dateMin" timezone="Asia/Pyongyang">
                    <template v-slot="{ inputValue, togglePopover }">
                      <div class="flex items-center">
                        <input
                          :value="inputValue"
                          class="mb-16"
                          readonly
                        />
                        <button
                          class="c-control-cart__btn"
                          @click="togglePopover()"
                        >選択</button>
                      </div>
                    </template>
                  </v-date-picker>
                </template>
                <div id="btn_checkout" class="c-btn c-btn--red box-center" @click.prevent="checkout" v-if="index + 1 == cartData.length && getTenantCategory(tenantCart.tenantId) != 5">{{tenantCart.orderType == 3 ? '確認' : '決済'}}画面に進む</div>
              </div>
            </div>
          </div>
        </div>
      </section>
       <alert :message="alert_msg" 
        :show="alert_show" 
        :closeModal="closeModal" 
        :confirm_show="confirm_show" 
        :confirm_message="confirm_msg" 
        :confirm_callback="confirm_callback" 
        :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel"
        :label_ok="confirm_label_ok"
        ></alert>
      <confirm-reservation 
        :callback="confirmCallback"
        :callbackComp="completeCallback" 
        :show="confirmReservationShow" 
        :closeModal="closeConfirmReservationPopup"
       />
      <drive-thru-modal :show="show_drivethru_modal" :onClose="closeLocationPopup" />
      <park-and-pickup-modal :show="show_parkandpickup_modal" :onClose="closeLocationPopup" />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getProvider, getTagsByProvider, getProviderByShopCategory, getMobileOrderConfig, getEventsAeonToDate } from "../store/firestore";
import PopAlert from "../components/PopAlert.vue";
import DriveThruModal from "../components/DriveThruModal.vue";
import ParkAndPickupModal from "../components/ParkAndPickupModal.vue";
import ConfirmReservation from "../components/ConfirmReservation.vue";
import dayjs from "dayjs";

export default Vue.extend({
  name: "MobileOrderCart",
  components: {
    'header-app': Header,
    'menu-app': Menu,
    'alert': Alert,
    PopAlert,
    DriveThruModal,
    ParkAndPickupModal,
    ConfirmReservation
  },
  mixins: [Tenant],
  async created(){
    const result = await getProviderByShopCategory(0)
    this.tenants = result;
    this.mobileOrderConfig = await getMobileOrderConfig()
  },
  data(){
    const cartData = this.$store.state.cart;
    for (const [key, tenantCart] of Object.entries(cartData)) {
      tenantCart.showTableNoInput = tenantCart.deliveryPlaceDetail.tableNo > 0;
      tenantCart.deliveryPlaceDetail = tenantCart.deliveryPlaceDetail || {};
    }
    const fromPage = Common.getUrlParam('from-page');
    if (fromPage) {
      this.$router.replace({query: null});
    } else {
      this.$store.dispatch('updateCart', { cartData, })
    }
    return {
      cartData: Object.values(cartData),
      tenants: [],
      errorCarNo: null,
      errorCarColor: null,
      errorParkingNo: null,
      errorTableNo: null,
      show_drivethru_modal: false,
      show_parkandpickup_modal: false,
      mobileOrderConfig: null,
      dateMax: dayjs().startOf('d').add(14,'d').toDate(),
      dateMin: dayjs().startOf('d').toDate(),
      masks: {
        input: 'YYYY-MM-DD',
      },
      confirmReservationShow: false,
    }
  },
  computed: {
    cartIsEmpty: function() {
      return !this.$store.state.cart || Object.keys(this.$store.state.cart).length == 0;
    },
    hasCartError: function() {
      return this.cartData
        ? Object.values(this.cartData)?.
          filter(tenantCart => { return tenantCart.tenantError || tenantCart.orderProducts?.filter(product => product.productError).length > 0 })?.length > 0
        : false
    }
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    isReservation() {
      //来店予約でかつ商品が存在する場合
      const cartData = {...this.$store.state.cart};
      for (const [key, tenantCart] of Object.entries(cartData)) {
        if (tenantCart && tenantCart.orderType == 3) {
          this.confirmReservationShow = true;
          return true;
        }
      }
    },
    openLocationPopup(type) {
      if(type == 'drivethru') {
        this.show_drivethru_modal = true;
      } else {
        this.show_parkandpickup_modal = true;
      }
    },
    openTableNoInput(originCart) {
      const cartData = {...this.$store.state.cart};
      for (const [key, tenantCart] of Object.entries(cartData)) {
        if(tenantCart.orderId == originCart.orderId){
          tenantCart.showTableNoInput = true;
        }
      }
      this.cartData = Object.values(cartData);
    },
    closeLocationPopup(type) {
      if(type == 'drivethru') {
        this.show_drivethru_modal = false;
      } else {
        this.show_parkandpickup_modal = false;
      }
    },
    getTenant(tenantId) {
      if(this.tenants.length) {
        return this.tenants.find(item => item.id == tenantId);
      }
      return undefined;
    },
    getTenantName(tenantId) {
      const tenant = this.getTenant(tenantId);
      if (tenant) {
        return tenant.shopName;
      }
    },
    getTenantCategory(tenantId) {
      const tenant = this.getTenant(tenantId);
      if (tenant) {
        return parseInt(tenant.shopCategoryType);
      }
      return 0;
    },
    getTenantTimebasePickup(tenantCart) {
      const tenantId = tenantCart.tenantId;
      const tenant = this.getTenant(tenantId);
      if (tenant) {
        const receiveDateMargin = tenantCart.handlingFormatSetting.receiveDateMargin > 0;
        const orderType =  tenantCart.orderType;
        const enableTimebasePickup = tenant.enableTimebasePickup;
        if (receiveDateMargin) {
          return !enableTimebasePickup;
        } else {
          return false;
        }
      }
      return false;
    },
    getTenantTimebaseReservation(tenantId) {
      const tenant = this.getTenant(tenantId);
      if (tenant) {
        return tenant.enableTimebaseReservation;
      }
      return false;
    },
    getEstimateTime(tenantCart) {
      const orderType = tenantCart.orderType;
      const tenant = this.getTenant(tenantCart.tenantId);
      if (orderType && tenant){
        let orderTypeString;
        switch(orderType){
          case 1: orderTypeString = 'pickup'; break;
          case 2: orderTypeString = 'delivery'; break;
          case 3: orderTypeString = 'reservation'; break;
        }
        return this.estimateTime(tenant, orderTypeString)
      }
    },
    getMaxReceveDate(margin) {
      return dayjs().startOf('day').add(margin, 'd').valueOf();
    },
    async incrementQuantity(originCart, index) {

      if (this.isReservation()) {
        return;
      }

      const cartData = {...this.$store.state.cart};
      for (const [key, tenantCart] of Object.entries(cartData)) {
        if(tenantCart.orderId == originCart.orderId){
          tenantCart.orderProducts[index].quantity++;
          tenantCart.orderProducts[index].tmpQuantity++;
        }
      }
      await this.$store.dispatch('updateCart', { cartData, })
      .catch(err => {
        if(err?.userMessage){
          this.alert(err.userMessage);
        } else {
          this.alert("エラーが発生しました。");
        }
      })
      this.cartData = Object.values(cartData);
    },
    async decrementQuantity(originCart, index) {

      if (this.isReservation()) {
        return;
      }

      const cartData = {...this.$store.state.cart};
      for (const [key, tenantCart] of Object.entries(cartData)) {
        if(tenantCart.orderId == originCart.orderId){
          if(tenantCart.orderProducts[index].quantity - 1 <= 0){
            await this.removeProduct(originCart, index);
            return;
          }
          if(tenantCart.orderProducts[index].quantity - 1 > 0){
            tenantCart.orderProducts[index].quantity--;
            tenantCart.orderProducts[index].tmpQuantity--;
          }
        }
      }
      await this.$store.dispatch('updateCart', { cartData, })
      .catch(err => {
        if(err?.userMessage){
          this.alert(err.userMessage);
        } else {
          this.alert("エラーが発生しました。");
        }
      })
      this.cartData = Object.values(cartData);
    },
    async changeNumberOfProduct(originCart, index, quantity) {
      const cartData = {...this.$store.state.cart};
      for (const [key, tenantCart] of Object.entries(cartData)) {
        if(tenantCart.orderId == originCart.orderId){
          if (parseInt(quantity) <= 0) {
            await this.removeProduct(originCart, index);
            return;
          }
          tenantCart.orderProducts[index].quantity = parseInt(quantity);
          tenantCart.orderProducts[index].tmpQuantity = parseInt(quantity);
        }
      }
      await this.$store.dispatch('updateCart', { cartData, })
      .catch(err => {
        if(err?.userMessage){
          this.alert(err.userMessage);
        } else {
          this.alert("エラーが発生しました。");
        }
      })
      this.cartData = Object.values(cartData);
    },
    async removeProduct(originCart, index) {

      if (this.isReservation()) {
        return;
      }

      
      const result = await this.confirm("この商品をカートから削除します。よろしいですか？", false);
      
      if (result) {
        const cartData = {...this.$store.state.cart};
        for (const [key, tenantCart] of Object.entries(cartData)) {
          if(tenantCart.orderId == originCart.orderId){
            const products = tenantCart.orderProducts;
            products?.splice(index, 1);
            if(products?.length == 0){
              delete cartData[key];
            }
          }
        }
        await this.$store.dispatch('updateCart', { cartData, })
        .catch(err => {
          if(err?.userMessage){
            this.alert(err.userMessage);
          } else {
            this.alert("エラーが発生しました。");
          }
        })
        this.cartData = Object.values(cartData);
      }
    },
    getProductCount(tenantCart) {
      return tenantCart.orderProducts.reduce((total, item) => {
        return total + item.quantity
      }, 0);
    },
    changeDeliveryPlace(originCart) {
      const cartData = {...this.$store.state.cart};
      const handlingFormat = originCart.handlingFormat;
      const tenant = this.getTenant(originCart.tenantId);
      let deliveryPlace = "";
      let handlingFormatSetting = undefined;
      switch (parseInt(handlingFormat)) {
        case 1: handlingFormatSetting = tenant?.handlingFormatToGo; deliveryPlace = "お持ち帰り"; break;
        case 2: handlingFormatSetting = tenant?.handlingFormatForHere; deliveryPlace = "店内でお食事"; break;
        case 3: handlingFormatSetting = tenant?.handlingFormatDeliveryLane; deliveryPlace = "ドライブスルー"; break;
        case 4: handlingFormatSetting = tenant?.handlingFormatDeliveryParking; deliveryPlace = "駐車場受け取り"; break;
        case 5: handlingFormatSetting = tenant?.handlingFormatReservation; deliveryPlace = "ご来店予約"; break;
      }
      for (const [key, tenantCart] of Object.entries(cartData)) {
        if(tenantCart.orderId == originCart.orderId){
          tenantCart.deliveryPlace = originCart.deliveryPlace;
          tenantCart.handlingFormat = parseInt(handlingFormat);
          tenantCart.handlingFormatSetting = handlingFormatSetting;
        }
      }
      this.$store.dispatch('updateCart', { cartData, })
      .catch(err => {
        if(err?.userMessage){
          this.alert(err.userMessage);
        } else {
          this.alert("エラーが発生しました。");
        }
      })
      this.cartData = Object.values(cartData);
    },
    getErrorTitle(tenantError) {
      console.log('tenantError',tenantError);
      if((tenantError.code && tenantError.code.indexOf("aeonregi") != -1) 
      || (tenantError.details?.code && tenantError.details?.code?.indexOf("aeonregi") != -1)) {
        const regiResult = tenantError.details?.result ? tenantError.details?.result : "";

        /*
        2000:決済NG  
        2001:与信NG(取扱範囲外カード)   "A01"or"A02" 
        2002:与信NG(カード番号エラー)   "G65"    
        2003:与信NG(有効期限エラー)     "G83"   
        2004:与信NG(機械調整中)         "A**"or"C**"  
        2005:与信NG(ストラタスエラー)   "E**"    
        2010:取消NG  
        2020:対象ORDER_DATAまたは共通内部ID、イオンレジIDなし（使用不可） 
        2030:対象ORDER_DATAなし    
        3000:パラメータエラー・内部エラー
        */

        switch (regiResult) {
          case "2000":
            return `決済エラー（2000）
登録カード情報が正しく、また利用可能な状態かをご確認ください。`;
          case "2001":
            return `決済エラー（2001）
取扱範囲外カードのため別のカードをご登録ください。`;
          case "2002":
            return `決済エラー（2002）
登録カード番号が正しいかをご確認ください。`;
          case "2003":
            return `決済エラー（2003）
登録カードが有効期限切れでないかをご確認ください。`;
          case "2004":
            return `決済エラー（2004:CAFISエラー）
しばらくたってから再度お試しください。`;
          case "2005":
            return `決済エラー（2005:PGエラー）
イオンタウン管理事務所へお問い合わせください。`;
          case "2010":
            return `決済エラー（2010）
しばらくたってから再度お試しください。それでもエラーになる場合は、イオンタウン管理事務所へお問い合わせください。`;
          case "2020":
            return `決済エラー（2020）
イオンタウン管理事務所へお問い合わせください。`;
          case "2030":
            return `決済エラー（2030）
登録カードをご確認ください。`;
          case "3000":
            return `決済エラー（3000）
イオンタウン管理事務所へお問い合わせください。`;
          default:
            return `決済エラー (${regiResult})
登録カードをご確認ください。`;
        }

        
      } else if (tenantError.code != "internal") {
        if (tenantError.message) {
          return tenantError.message;
        }
        let errorCode = tenantError.details?.code ? tenantError.details?.code : "E9999";
        console.log(`errorCode ${errorCode} message ${tenantError.message}`,tenantError);
        return this.getErrorMessage(errorCode);
      } else {
        let errorCode = tenantError.details?.code ? tenantError.details?.code : "E9999";
        console.log(`errorCode ${errorCode} message ${tenantError.message}`,tenantError);
        return this.getErrorMessage(errorCode);
      }
    },
    getErrorMessage(errorCode) {
      switch (errorCode) {
        case "E2001":
          return `注文エラー（11）\r\nアプリが最新でないか商品等が変更された可能性がございます。アプリのアップデート、もしくは再度お試しください。`;
        case "E1001":
          return `注文エラー（12）\r\nイオンタウン管理事務所へお問い合わせください`;
        case "E1002":
          return `注文エラー（13）\r\nイオンタウン管理事務所へお問い合わせください`;
        case "E2002":
          return `注文エラー（14）\r\nイオンタウン管理事務所へお問い合わせください`;
        case "E1003":
          return `注文エラー（15）\r\n商品等が変更された可能性がございます。お手数をお掛け致しますが再度お試しください。`;
        case "E1004":
          return `注文エラー（16）\r\n対象店舗の受付時間外です`;
        case "E1005":
          return `注文エラー（17）\r\n対象店舗の受付時間外です`;
        case "E1006":
          return `注文エラー（18）\r\nイオンタウン管理事務所へお問い合わせください`;
        case "E1007":
          return `注文エラー（19）\r\nイオンタウン管理事務所へお問い合わせください`;
        case "E1008":
          return `注文エラー（20）\r\nお手数をお掛け致しますが再度お試しください。それでもエラーになる場合は、イオンタウン管理事務所へお問い合わせください。`;
        case "E1009":
          return `注文エラー（21）\r\n予約枠が満席になった可能性がございます。お手数をお掛け致しますが再度お試しください。`;
        case "E1010":
          return `注文エラー（22）\r\nイオンタウン管理事務所へお問い合わせください`;
        case "E1011":
          return `注文エラー（23）\r\nイオンタウン管理事務所へお問い合わせください`;
        case "E1012":
          return `注文エラー（24）\r\nイオンタウン管理事務所へお問い合わせください`;
        case "E1013":
          return `注文エラー（25）\r\nイオンタウン管理事務所へお問い合わせください`;
        case "E1014":
          return `注文エラー（26）\r\nイオンタウン管理事務所へお問い合わせください`;
        case "E1015":
          return `注文エラー（27）\r\nイオンタウン管理事務所へお問い合わせください`;
        default:
          return `注文エラー（${errorCode}）\r\nイオンタウン管理事務所へお問い合わせください`;
      }
    },
    updateTableNo(event, tenantCart) {
      const value = parseInt(event.target.value);
      if (
        (value >= 1 && value <= 19)
        || (value >= 30 && value <= 39)
        || (value >= 100 && value <= 199)
        || (value >= 300 && value <= 399)
      ) {
        //OK
        tenantCart.deliveryPlaceDetail.tableNo = value;
        return true;
      } else {
        //NG
        tenantCart.deliveryPlaceDetail.tableNo = "";
        this.alert("テーブル番号が正しくありません。テーブル上に記載の番号をご入力ください。");
        return false;
      }
    },
    updateCarNo(event) {
      const value = event.target.value;
      this.errorCarNo = '';
      const regex = /([0-9]{2})-*([0-9]{2})/
      const matched = value.match(regex);
      if (matched) {
        let cartData = {...this.$store.state.cart};
        for (const [key, tenantCart] of Object.entries(cartData)) {
          if(!tenantCart.deliveryPlaceDetail) {
            cartData[key].deliveryPlaceDetail = {};
          }
          cartData[key].deliveryPlaceDetail.carNo = `${matched[1]}-${matched[2]}`;
        }
        this.$store.dispatch('updateCart', { cartData, })
        .catch(err => {
          if(err?.userMessage){
            this.alert(err.userMessage);
          } else {
            this.alert("エラーが発生しました。");
          }
        })
        this.cartData = Object.values(cartData);
        event.target.value = `${matched[1]}-${matched[2]}`;
      } else {
        this.errorCarNo = '車のナンバーは4桁数字で入力してください。';
      }
    },
    updateCarColor(event) {
      this.errorCarColor = '';
      const value = String(event.target.value);
      let cartData = {...this.$store.state.cart};
      for (const [key, tenantCart] of Object.entries(cartData)) {
        if(!tenantCart.deliveryPlaceDetail) {
          cartData[key].deliveryPlaceDetail = {};
        }
        cartData[key].deliveryPlaceDetail.carColor = value;
      }
      this.$store.dispatch('updateCart', { cartData, })
      .catch(err => {
        if(err?.userMessage){
          this.alert(err.userMessage);
        } else {
          this.alert("エラーが発生しました。");
        }
      })
      this.cartData = Object.values(cartData);
    },
    updateParkingNo(event) {
      const value = event.target.value;
      this.errorParkingNo = '';
      const regex = /B-[0-9]+/
      const matched = value.match(regex);
      if (matched) {
        let cartData = {...this.$store.state.cart};
        for (const [key, tenantCart] of Object.entries(cartData)) {
          if(!tenantCart.deliveryPlaceDetail) {
            cartData[key].deliveryPlaceDetail = {};
          }
          cartData[key].deliveryPlaceDetail.parkingNo = value;
        }
        this.$store.dispatch('updateCart', { cartData, })
        .catch(err => {
          if(err?.userMessage){
            this.alert(err.userMessage);
          } else {
            this.alert("エラーが発生しました。");
          }
        })
        this.cartData = Object.values(cartData);
      } else {
        this.errorParkingNo = '駐車場番号が正しくありません。';
      }
    },
    checkout() {
      if(!this.isUserOrderable()){
        this.alert("モバイルオーダーのご利用にはログイン・本人確認が必要です。");
        return;
      }
      const cartData = {...this.$store.state.cart};
      const firstItem = Object.values(cartData).find(x=>x!==undefined);
      if (!firstItem) {
        this.alert("カートに商品がありません。");
        return;
      } else if (firstItem?.handlingFormat == 3 || firstItem?.handlingFormat == 4) {
        if(!firstItem.deliveryPlaceDetail.carNo) {
          this.errorCarNo = "車のナンバーが入力されていません。";
        }
        if(!firstItem.deliveryPlaceDetail.carColor) {
          this.errorCarColor = "車の色が選択されていません";
        }
        if (firstItem.handlingFormat == 4 && (!firstItem.deliveryPlaceDetail.parkingNo || firstItem.deliveryPlaceDetail.parkingNo == "B-")) {
          this.errorParkingNo = '駐車場番号が入力されていません';
        }
      }
      if(this.errorParkingNo || this.errorCarNo || this.errorCarColor) {
        this.alert("入力内容にエラーがあります。ご確認ください。");
        return;
      }
      this.$store.dispatch('updateCart', { cartData, })
      .then(() => {
        this.$router.push('/mobileorder/checkout');
      })
      .catch(err => {
        
        if(err?.userMessage){
          this.alert(err.userMessage);
        } else {
          this.alert("エラーが発生しました。");
        }
        this.cartData = Object.values(this.$store.state.cart);
      })
    },
    //来店予約かどうかで戻りの状態を変更する
    isShowConfirmReservation() {
      var orderType = false;
      for (var i=0; i < this.cartData.length; i++) {
        if (this.cartData[i].orderType) {
          orderType = (this.cartData[i].orderType == 3) ? true : false;
          break;
        }
      }
      if (orderType) {
        this.confirmReservationShow = true;
      } else {
        this.backPagePrevious();
      }
    },
    isEnableTimebase(cartData) {
      const tenant = this.getTenant(cartData.tenantId);
      if (!tenant) {
        return false;
      }
      if ((cartData.orderType == 1 && tenant.enableTimebasePickup)
        || (cartData.orderType == 3 && tenant.enableTimebaseReservation)) {
        return false;
      } 
      return true;
    },
    closeConfirmReservationPopup() {
      this.confirmReservationShow = false;
    },
    completeCallback() {
      this.$router.push('/mobileorder/checkout');
    },
    // カートクリア
    async confirmCallback() {
      let tenantId,orderType;
      for (var i=0; i < this.cartData.length; i++) {
        if (this.cartData[i].tenantId) {
          tenantId = this.cartData[i].tenantId;
          orderType = this.cartData[i].orderType;
          break;
        }
      }
      if (tenantId && orderType == 3) {
          //来店予約の時にカート情報消して詳細画面戻る
        await this.$store.dispatch('clearCart');
        this.$router.push(`/mobileorder/shop/${tenantId}/reservation`);
      } else {
        this.backPagePrevious();
      }    
    }
  }
});
</script>

